import axios from 'axios';

const memberCenterService = {
  fetchUserCredits: (params = { limit: 24, page: 1 }) => {
    return axios.get('/api/user_credits', {
      params,
    });
  },
  fetchMemberPoints: (params = { limit: 24, page: 1 }) => {
    return axios.get('/api/member_points', {
      params,
    });
  },
  // Rules can exceed the API default limit of 24, so temporarily pass limit=100 as a short-term fix.
  fetchMemberPointRules: ({ rule_type, limit = 100 } = {}) => {
    return axios.get('/api/member_point_rules', {
      params: { rule_type, limit },
    });
  },
  fetchFulfillmentSummary: (limit) => {
    return axios.get('/api/member_point_fulfillments/summary', {
      params: { limit },
    });
  },
  checkRedeemGiftPromotionExist: () =>
    axios.get('/api/promotions/is_redeem_gift_promotion_exist'),
  checkMemberReward: (userId) =>
    axios.post(`/api/users/${userId}/send_member_info_reward`),
  checkMemberRewardForLINEOrFB: (userId) =>
    axios.get(`/api/users/${userId}/info_reward_eligibility`),
};

export default memberCenterService;
